import ChartAPI from "../../apps/common/chart-api";

/** Группировка по 3 дня: 10–12 → 10, 14–16 → 14. dateStr = "YYYY-MM-DD". */
function getGroupKeyForDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr + "T00:00:00Z");
  const day = d.getUTCDate();
  const blockStartDay = day - ((day - 1) % 3);
  d.setUTCDate(blockStartDay);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(d.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

// Yandex.Metrika counter
(function (m, e, t, r, i, k, a) {
  m[i] =
    m[i] ||
    function () {
      (m[i].a = m[i].a || []).push(arguments);
    };
  m[i].l = 1 * new Date();
  for (var j = 0; j < document.scripts.length; j++) {
    if (document.scripts[j].src === r) {
      return;
    }
  }
  (k = e.createElement(t)),
    (a = e.getElementsByTagName(t)[0]),
    (k.async = 1),
    (k.src = r),
    a.parentNode.insertBefore(k, a);
})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
ym(91126829, "init", {
  clickmap: true,
  trackLinks: true,
  accurateTrackBounce: true,
  webvisor: true,
});

export default {
  namespaced: true,
  state: {
    uspLists: [
      {
        uspId: 0,
        loading: false,
        selectedCompetitor: null,
        selectedCompetitorOptions: [],
        items: null,
        items_raw: [],
      },
    ],
    uspType: "is_title",
  },
  actions: {
    initUspLists({ commit, dispatch, rootGetters, getters }) {
      let uspList = [];
      for (let i = 0; i < 2; i++) {
        // Создаем список всех рекламодателей (проект + конкуренты)
        let allAdvertisers = [];
        
        // Добавляем текущий проект с типом "project"
        allAdvertisers.push({
          ...rootGetters["currentProject"],
          advertiser_type: "project",
          uspId: i,
        });
        
        // Добавляем всех конкурентов
        rootGetters["competitors"].forEach((competitor) => {
          allAdvertisers.push({
            ...competitor,
            uspId: i,
          });
        });
        
        // Сортируем список: сначала рекламодатель с типом "project", затем остальные в алфавитном порядке
        let sortedCompetitorsWithId = allAdvertisers.sort((a, b) => {
          // Проверяем, является ли рекламодатель проектом (advertiser_type = "project")
          const aIsProject = a.advertiser_type === "project";
          const bIsProject = b.advertiser_type === "project";
          
          // Если один из них проект, а другой нет - проект идет первым
          if (aIsProject && !bIsProject) return -1;
          if (!aIsProject && bIsProject) return 1;
          
          // Если оба проекта или оба не проекта - сортируем по названию
          // Используем безопасное сравнение на случай отсутствия title
          const aTitle = a.title || '';
          const bTitle = b.title || '';
          return aTitle.localeCompare(bTitle, 'ru', { sensitivity: 'base' });
        });
        
        uspList.push({
          uspId: i,
          loading: false,
          selectedCompetitor: null,
          selectedCompetitorOptions: sortedCompetitorsWithId,
          items: null,
          items_raw: [],
        });
      }
      commit("updateUspLists", uspList);
      // dispatch('fetchUspList', 0)
    },

    async selectUspCompetitor({ commit, dispatch, getters }, payload) {
      const competitor = payload && payload.competitor !== undefined ? payload.competitor : payload;
      const uspListId = payload && payload.uspListId !== undefined ? payload.uspListId : (competitor && competitor.uspId);
      if (competitor == null) {
        const list = uspListId != null ? getters["uspLists"][uspListId] : null;
        if (list) {
          commit("updateUsp", {
            ...list,
            selectedCompetitor: null,
            items: null,
            items_raw: [],
          });
        }
        return;
      }
      const listId = competitor.uspId != null ? competitor.uspId : uspListId;
      const uspToEdit = getters["uspLists"][listId];
      uspToEdit.selectedCompetitor = competitor;
      commit("updateUsp", uspToEdit);
      await dispatch("fetchUspList", listId);
    },

    async selectUspType({ commit, dispatch, getters }, uspType) {
      commit("updateUspType", uspType);
      for (let i = 0; i < getters["uspLists"].length; i++) {
        if (getters["uspLists"][i].selectedCompetitor) {
          await dispatch("fetchUspList", getters["uspLists"][i].uspId);
        }
      }
    },

    async fetchUspList({ commit, dispatch, getters, rootGetters }, uspId) {
      let studObj = new ChartAPI();
      let url = getters["uspDownloadLink"];
      let competitorId = getters["uspLists"][uspId].selectedCompetitor["id"];
      commit(
        "filters/updateResultsPeriod",
        rootGetters["filters/dateRangeString"],
        { root: true }
      );
      commit("updateUsp", {
        ...getters["uspLists"][uspId],
        loading: true,
      });
      url += `&advertiser=${competitorId}`;
      let jsonOurResponse = await studObj.sendRequest(
        "getUsp",
        rootGetters["currentProjectId"],
        url
      );
      let uspList = getters["uspLists"][uspId];
      uspList.items_raw = jsonOurResponse;
      uspList.items = [];
      commit("processUspRequest", uspList);
    },
    async fetchUspListSelected({ commit, dispatch, getters, rootGetters }) {
      dispatch("filters/initSettings", null, { root: true });
      getters.uspLists.forEach((uspList) => {
        if (uspList.selectedCompetitor) {
          dispatch("fetchUspList", uspList.uspId);
        }
      });
    },
  },
  mutations: {
    /** Сброс выбранных рекламодателей и данных при входе на страницу УТП */
    resetUspSelections(state) {
      state.uspLists = state.uspLists.map((list) => ({
        ...list,
        selectedCompetitor: null,
        items: null,
        items_raw: [],
        loading: false,
      }));
    },
    updateUspLists(state, uspLists) {
      state.uspLists = uspLists;
    },
    updateUsp(state, usp) {
      const index = state.uspLists.findIndex((el) => el.uspId === usp.uspId);
      if (index !== -1) state.uspLists.splice(index, 1, usp);
    },
    updateUspType(state, uspType) {
      state.uspType = uspType;
    },
    processUspRequest(state, uspList) {
      if (uspList.items_raw === undefined) {
        uspList.items = [];
        uspList.loading = false;
        const idx = state.uspLists.findIndex((el) => el.uspId === uspList.uspId);
        if (idx !== -1) state.uspLists.splice(idx, 1, uspList);
        return;
      }
      const raw = uspList.items_raw;
      const isNewFormat = raw.length > 0 && raw[0].first_seen !== undefined && raw[0].ad_usp !== undefined;
      if (isNewFormat) {
        // Группируем по last_seen: чем ближе к концу выборки — тем выше в списке
        const upsByDate = {};
        for (let i = 0; i < raw.length; i++) {
          const item = raw[i];
          const groupKey = getGroupKeyForDate(item.last_seen || item.first_seen);
          if (!groupKey) continue;
          if (!upsByDate[groupKey]) upsByDate[groupKey] = [];
          upsByDate[groupKey].push({
            ad_usp: item.ad_usp,
            ad_entity_url: item.ad_entity_url,
            frequency_pct: item.frequency_pct,
            status: item.status,
          });
        }
        // Внутри каждой группы — по убыванию frequency_pct
        Object.keys(upsByDate).forEach((key) => {
          upsByDate[key].sort((a, b) => (b.frequency_pct || 0) - (a.frequency_pct || 0));
        });
        let uspForSort = Object.keys(upsByDate).map((key) => [key, upsByDate[key]]);
        uspForSort.sort((a, b) => new Date(b[0]) - new Date(a[0])); // последние last_seen сверху
        uspList.items = uspForSort;
      } else {
        const upsByDate = {};
        for (let i = 0; i < raw.length; i++) {
          const currentUps = raw[i];
          const key = currentUps["date"] || currentUps.visible_date;
          if (!key) continue;
          if (!upsByDate[key]) upsByDate[key] = [];
          upsByDate[key].push(currentUps["text"] != null ? currentUps["text"] : currentUps.ad_usp);
        }
        let uspForSort = Object.keys(upsByDate).map((key) => [key, upsByDate[key]]);
        uspForSort.sort((a, b) => new Date(b[0]) - new Date(a[0]));
        uspList.items = uspForSort;
      }
      uspList.loading = false;
      const index = state.uspLists.findIndex(
        (el) => el.uspId === uspList.uspId
      );
      if (index !== -1) state.uspLists.splice(index, 1, uspList);
    },
  },
  getters: {
    uspLists(state) {
      return state.uspLists;
    },
    uspType(state) {
      return state.uspType;
    },
    uspListsLength(state) {
      return state.uspLists.length;
    },
    uspDownloadLink(state, getters, rootState, rootGetters) {
      let downloadLink =
        "?" +
        rootGetters["filters/dateRangeParam"] +
        rootGetters["filters/searchEngineParam"] +
        rootGetters["filters/keywordsTypesParam"] +
        rootGetters["filters/deviceTypesParam"] +
        rootGetters["filters/keywordsParam"] +
        rootGetters["filters/keywordsTypesParam"] +
        rootGetters["filters/geoLocationsParam"];
      if (state.uspType) {
        downloadLink += `&${state.uspType}=true`;
      }
      return downloadLink;
    },
  },
};
